import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/CheckableInput/CheckableInput.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CHECKABLE_INPUT_CLASSNAME_MAP = {};
var CheckableInput = forwardRef((_a, ref) => {
  var _b = _a,
    {
      type,
      className
    } = _b,
    rest = __objRest(_b, ["type", "className"]);
  return /* @__PURE__ */jsx("input", __spreadValues({
    ref,
    type,
    className: clsx("pd:checkable-input", className)
  }, rest));
});
var CheckableInput_default = CheckableInput;
export { CHECKABLE_INPUT_CLASSNAME_MAP, CheckableInput_default };